export default function Separator() {
  return (
    <div className="w-full py-7">
      <hr className="border-[rgba(199,155,242,0.25)]" />
    </div>
  )
}
